import { render, staticRenderFns } from "./SetCertificatePass.vue?vue&type=template&id=e571d830&scoped=true"
import script from "./SetCertificatePass.vue?vue&type=script&lang=js"
export * from "./SetCertificatePass.vue?vue&type=script&lang=js"
import style0 from "./SetCertificatePass.vue?vue&type=style&index=0&id=e571d830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e571d830",
  null
  
)

export default component.exports